<template>
  <Popover :is-open="isUserFlyoutOpen" @mouseenter="openUserFlyout">
    <template #action>
      <Backdrop
        :show="isUserFlyoutOpen && !isMobile"
        class="z-40"
        @click="closeUserFlyout"
      />
      <AgsLink
        size="sm"
        :to="toLocalePath({ name: routeList.account.name })"
        :aria-label="$t('navigation.my_account')"
      >
        <IconLogin class="h-7 w-6 cursor-pointer" />
        <span class="header-main-menu__login hidden lg:flex">
          {{ $t('navigation.my_account') }}
        </span>
      </AgsLink>
    </template>
    <template v-if="user" #content>
      <div
        class="border-gray-200 relative w-64 bg-white py-1 shadow-xl"
        @mouseleave="closeUserFlyout"
      >
        <div class="relative z-50 w-full p-4">
          <span class="text-xs" data-mf-replace-inner="****">{{
            userGreeting
          }}</span>
          <hr />
          <p class="mt-3">
            <AgsLink
              :to="toLocalePath('/account/user')"
              size="sm"
              class="w-full bg-black p-3 font-bold uppercase text-white"
              :dark-on-active="false"
            >
              {{ $t('myaccount.profile_menu') }}
            </AgsLink>
          </p>
          <p>
            <AgsLink
              :to="toLocalePath('/account/orders')"
              size="sm"
              class="mt-3 w-full bg-black p-3 font-bold uppercase text-white"
              :dark-on-active="false"
            >
              {{ $t('myaccount.orders_menu') }}
            </AgsLink>
          </p>
          <NuxtLink
            size="sm"
            class="mt-3 inline-flex w-full shrink-0 grow-0 cursor-pointer gap-2 border border-black p-3 text-sm uppercase leading-none tracking-wide md:block"
            data-qa="logout"
            @click="!isSubmitting && logout()"
          >
            {{ $t('global.sign_out') }}
          </NuxtLink>
        </div>
      </div>
    </template>
  </Popover>
</template>

<script setup lang="ts">
const { openUserFlyout, closeUserFlyout, isUserFlyoutOpen } = useUiState()
const i18n = useI18n()
const { isInList: isFinland } = useCountryCheck(['fi'])
const { isMobile } = useDeviceType()
const { toLocalePath } = useRouteHelpers()
const [{ user }, { logout, isSubmitting }] = await Promise.all([
  useAgsUser(),
  useAuthentication('logout'),
])

const userGreeting = computed(() => {
  if (!user.value) {
    return ''
  }

  if (isFinland.value) {
    return i18n.t('global.user_greeting', {
      firstName: user.value.firstName,
      lastName: user.value.lastName,
    })
  }

  switch (user.value.gender) {
    case 'm':
      return i18n.t('global.user_greeting_m', {
        firstName: user.value.firstName,
        lastName: user.value.lastName,
      })
    case 'f':
      return i18n.t('global.user_greeting_f', {
        firstName: user.value.firstName,
        lastName: user.value.lastName,
      })
    default:
      return i18n.t('global.user_greeting', {
        firstName: user.value.firstName,
        lastName: user.value.lastName,
      })
  }
})
</script>

<style scoped>
:deep(.panel-container) {
  @apply overflow-hidden;
}
</style>
